import { render, staticRenderFns } from "./FloodCancellation.vue?vue&type=template&id=22c776eb&scoped=true"
import script from "./FloodCancellation.vue?vue&type=script&lang=js"
export * from "./FloodCancellation.vue?vue&type=script&lang=js"
import style0 from "./FloodCancellation.vue?vue&type=style&index=0&id=22c776eb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c776eb",
  null
  
)

export default component.exports